export const oneParkingStyles = {
	header: {
		backgroundColor: '#212121',
	},
	sidebar: {
		backgroundColor: '#212121',
		color: 'white',
	},
	button: {
		backgroundColor: '#1c559a',
		color: '#fff',
		border: '1px solid #000',
		fontWeight: 600,
		':hover': {
			backgroundColor: '#7D7D7D',
			borderColor: '#000',
		},
	},
	text: {
		color: '#050709',
		buttonLoadingColor: '#7D7D7D',
	},
	title: {
		color: '#fff',
	},
	table: {
		headerBackgroundColor: '#f2cc39',
		headerTextColor: '#050709',
	},
	platformName: {
		name: 'One Parking Platform',
	},
	logo: {
		small: {
			src: '/oneParking/one-parking-icon.png',
			height: 35,
			width: 35,
		},
		large: {
			src: '/oneParking/one-parking-logo.png',
			height: 40,
			width: 140,
		},
	},
	favicon: {
		src: '/oneParking/one-parking-icon.png',
	},
	socials: {
		instagram: 'https://www.instagram.com/we_oneparking',
		facebook: 'https://www.facebook.com/OneParkingInc?fref=ts',
		linkedIn: 'https://www.linkedin.com/company/one-parking-inc-',
		youtube: 'https://www.youtube.com/channel/UCzmBO4aTAMXs68xabzp1hzQ',
	},
	siteUrl: 'https://oneparking.com/',
	orgName: 'One Parking',
};
